export default __webpack_public_path__ + "static/image_acceuil_s-8235ce4cd3f406c5ba5c8fd8022878b7.jpg";